export const faqs = [
  {
    question: 'What exactly do I get for $27?',
    answer:
      'One 40-page visual PDF guide with twelve complete 40-minute team handball lessons, plus five bonus resources: 16 Printable Activity Cards, the Large-Group Organization Guide, the Handball Skills Progression Map, Student Observation and Assessment Sheets, and Lesson Planning Worksheets. It’s a one-time payment of $27 USD.',
  },
  {
    question: 'I’m new to handball. Can I still teach these lessons?',
    answer:
      'Yes — that’s who it’s written for. Each lesson sets out the goal, equipment, diagram, timings and instructions, and the lessons follow a clear sequence. Start at Lesson 1 and build from there.',
  },
  {
    question: 'What ages are the lessons designed for?',
    answer:
      'Children aged 8–11 learning team handball (not wall handball). Activities include easier and harder options so you can adjust to your group.',
  },
  {
    question: 'Can I adapt it to my class size and lesson length?',
    answer:
      'Yes. The guide includes adaptations for 30-, 40- and 50-minute lessons and for different class sizes, including organization options for larger classes. The Large-Group Organization Guide adds group sizes, station setups and rotations.',
  },
  {
    question: 'What space and equipment do I need?',
    answer:
      'Soft balls, cones and marked targets. You don’t need a regulation handball court — activities are laid out with simple markers in a gym, playground or similar space.',
  },
  {
    question: 'Is this a physical book?',
    answer:
      'No. Everything is digital: PDF files you can read on a computer, tablet or phone, or save and print. Nothing is shipped.',
  },
  {
    question: 'How do I receive the files?',
    answer: 'Your download links are emailed after payment is approved. You don’t need to create an account or password.',
  },
  {
    question: 'What language is the material in?',
    answer:
      'The teaching text is in English. Some labels in the original guide use Spanish terms; the real page previews show the current edition.',
  },
  {
    question: 'How do I pay?',
    answer: 'Through a secure checkout. The final payment methods and currency are shown at checkout before you pay.',
  },
  {
    question: 'Do I need the optional extra packs?',
    answer:
      'No. “Handball Class Ready — The Next 12 Lessons” and “30 Small-Sided Handball Games” are separate, optional products sold at checkout. The $27 pack is complete without them.',
  },
  {
    question: 'What if it isn’t right for my classes?',
    answer:
      'You’re covered by the 10-day money-back guarantee. If it isn’t right for you, email support@stockdigital.shop within 10 days of purchase to request a refund.',
  },
];
